module.exports = __webpack_public_path__ + "static/lvmh-logo-07c382c35cf585690ee349c7a2f491d1.jpeg";